import React from "react";
import { Cell, DayHead, Grid, Legend, LegendItem, RowLabel, Swatch } from "./RunHeatmap.styles";
import type { RunHeatmapProps } from "./RunHeatmap.types";

/** Rows by days: one coloured cell per day, with a tooltip from the caller's own words. */
export const RunHeatmap: React.FC<RunHeatmapProps> = ({ days, rows, ariaLabel, legend, className }) => (
  <Grid className={className} $columns={days.length} role="table" aria-label={ariaLabel}>
    <span role="presentation" />
    {days.map((day, index) => (
      <DayHead key={`${day}-${index}`} role="columnheader" $current={index === days.length - 1}>
        {day}
      </DayHead>
    ))}
    {rows.map((row) => (
      <React.Fragment key={row.id}>
        <RowLabel role="rowheader">
          {row.icon}
          {row.label}
        </RowLabel>
        {row.cells.map((cell, index) => (
          <Cell
            key={index}
            role="cell"
            $status={cell.status}
            data-status={cell.status}
            title={cell.tooltip}
            aria-label={cell.tooltip}
          />
        ))}
      </React.Fragment>
    ))}
    {legend ? (
      <Legend aria-label="Legend">
        {legend.map((item) => (
          <LegendItem key={item.status}>
            <Swatch $status={item.status} />
            {item.label}
          </LegendItem>
        ))}
      </Legend>
    ) : null}
  </Grid>
);

export default RunHeatmap;
